<template>
  <!-- bred crumb section start -->
  <section class="about-crumb lg:pt-[8rem] pt-[6rem] pb-[2rem]">
  </section>
  <div class="bg-primary py-2 globl z-40 down-section">
    <div class="-rotate-3 bg-nu2 py-4 -mx-5 -z-10">
      <div class="text-nu1 text-3xl font-bold text-center">YOU ONLY NEED ONE PLAY</div>
    </div>
  </div>
  <section class="game-statis">
    <div class="bg-[url(/img/about/global.png)] bg-no-repeat bg-center bg-contain h-[400px] flex flex-col justify-center items-center"  data-aos="zoom-in">
      <div class=" flex justify-around w-[400px] h-[100px]">
        <div class="text-center" data-aos="fade-right">
          <div class="text-[#47ffbc] font-black text-5xl text-center">160+</div>
          <div class="text-[#ffffff] text-sm">Games</div>
        </div>
        <div class="text-center" data-aos="fade-left">
          <div class="text-[#47ffbc] font-black text-5xl text-center">10+</div>
          <div class="text-[#ffffff] text-sm">Laguages</div>
        </div>
      </div>
      <div class="text-[#ffffff] max-w-[500px] text-center">
        Launched in 2017, TARA PLAY has quickly become Philippine most trusted real - money slots publisher.
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-flow-col md:grid-rows-6 gap-4 max-w-[90%] md:max-w-[710px] m-auto mt-10">
      <div class="row-span-6 col-span-1 md:col-span-5 w-full md:w-[400px] bg-[#18191f] rounded-xl">
        <div class="flex flex-col justify-between p-[10px] h-full">
          <div class="flex flex-row mt-3">
            <div class="text-nu1 font-black text-3xl md:text-4xl leading-[50px] text-center"  data-aos="fade-right">160+</div>
            <div class="bg-primary ml-2 mr-2 w-[2px]"></div>
            <div class="flex flex-col justify-center" data-aos="fade-left">
              <div class="text-nu1">TARA PLAY</div>
              <div class="text-nu1">Games</div>
            </div>
          </div>
          <img src="/img/game/all.png" class="w-[100%] mb-1 md:mb-4" data-aos="zoom-in" />
          <!-- <div class="grid grid-cols-4 md:grid-flow-col md:grid-rows-4 gap-2 mt-4" data-aos="zoom-in">
            <img v-for="game in gameIcons" :key="game.id" :src="game.icon" class="row-span-1 col-span-1 h-[60px] w-[60px] md:h-[80px] md:w-[80px]"></img>
          </div> -->
        </div>
      </div>
      <div class="row-span-3 col-span-1 md:col-span-3 w-full md:w-[300px] bg-[#18191f] rounded-xl">
        <div class="flex flex-row justify-between p-[10px]">
          <div class="text-nu1 w-2/3" data-aos="zoom-in">
            <div class="font-black text-4xl">24-HOUR</div>
            <div class="text-base">Operator Access</div>
            <div class="text-sm mt-2">24X7 access</div>
            <div class="text-xs">ensuers operators'busineses runs smothly al tear long.</div>
          </div>
          <div class="flex justify-center md:block mt-4 md:mt-0" data-aos="fade-up">
            <img class="h-[120px] md:h-[170px] mt-[10px]" src="/img/about/rocket.png" alt="" />
          </div>
        </div>
      </div>
      <div class="row-span-3 col-span-1 md:col-span-3 w-full md:w-[300px] bg-[#18191f] rounded-xl">
        <div class="flex flex-col justify-between space-between p-[10px] h-full">
          <div class="text-nu1" data-aos="fade-left">
            <div class="font-black text-3xl md:text-4xl">10+</div>
            <div class="text-base">Languages Supported</div>
          </div>
          <div class="grid grid-cols-5 gap-2 mt-4" data-aos="zoom-in">
            <img v-for="conutry in countryIcons" :key="conutry.id" :src="conutry.icon" class="row-span-1 col-span-1 w-[40px] md:w-15" />
          </div>
        </div>
      </div>
    </div>
    <div class="max-w-[90%] md:max-w-[710px] m-auto mt-10 text-nu1">
      <div class="bf-color text-2xl" data-aos="fade-right">
        About Us
      </div>
      <div class="text-sm" data-aos="fade-up">
        <div class="mt-4">
          1.Make from Philippines and offer games for all the Philippine players
        </div>
        <div class="mt-4">
          2.Only offer games for the trust operators and support for multi ways to complain
        </div>
        <div class="mt-4 mb-4">
          3. Start from 2017 and grow up with the trust of al the players
        </div>
      </div>
      <div class="bf-color text-2xl" data-aos="fade-right">
        About Games
      </div>
      <div class="text-sm" data-aos="fade-up">
        <div class="mt-4 leading-8">
          As a well know games publisher in Philippines, TARA PLAY merges casual,social, and real-money 
          experiences into one captivating games app. We take pride in our originality and individuality, 
          offering Philippine players cutting-edge games with compelling storylines, immersive sound effects, 
          and breathtaking animations-ensuring an unforgettable experience every time you play.
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
  import AOS from 'aos';
  const gameIcons = [
    {
      id: 541,
      name: 'Power of the Kraken Ⅰ',
      icon: '/img/icon/541.png',
    },
    {
      id: 544,
      name: 'Fortune Gems I',
      icon: '/img/icon/544.png',
    },
    {
      id: 545,
      name: 'Crazy 777 I',
      icon: '/img/icon/545.png',
    },
    {
      id: 547,
      name: 'Jurassic Kingdom',
      icon: '/img/icon/547.png',
    },
    {
      id: 548,
      name: 'Super Ace I',
      icon: '/img/icon/548.png',
    },
    {
      id: 555,
      name: 'Dragon Hatch I',
      icon: '/img/icon/555.png',
    },
    {
      id: 557,
      name: 'Super 777',
      icon: '/img/icon/557.png',
    },
    {
      id: 559,
      name: 'Fortune Gems II',
      icon: '/img/icon/559.png',
    },
    {
      id: 560,
      name: 'Diamond 777',
      icon: '/img/icon/560.png',
    },
    {
      id: 574,
      name: 'Ganesha Gold I',
      icon: '/img/icon/574.png',
    },
    {
      id: 575,
      name: 'Fortune Gems IV',
      icon: '/img/icon/575.png',
    },
    {
      id: 585,
      name: 'Archer Ⅱ',
      icon: '/img/icon/585.png',
    },
    {
      id: 595,
      name: 'Jungle Delight',
      icon: '/img/icon/595.png',
    },
    {
      id: 693,
      name: 'Double Nuggets',
      icon: '/img/icon/693.png',
    },
    {
      id: 694,
      name: 'Xerxes',
      icon: '/img/icon/694.png',
    },
    {
      id: 706,
      name: 'Jackpot Link',
      icon: '/img/icon/706.png',
    },
    {
      id: 737,
      name: 'Sparky & Shortz Ⅰ',
      icon: '/img/icon/737.png',
    },
    {
      id: 748,
      name: 'Mahjong Ways II',
      icon: '/img/icon/748.png',
    },
    {
      id: 774,
      name: 'Fever 777',
      icon: '/img/icon/774.png',
    },
    {
      id: 778,
      name: 'Power of the Kraken Ⅲ',
      icon: '/img/icon/778.png',
    },
  ]
  const countryIcons = [
    { id: 1, icon: '/img/about/country/1.png' },
    { id: 2, icon: '/img/about/country/2.png' },
    { id: 3, icon: '/img/about/country/3.png' },
    { id: 4, icon: '/img/about/country/4.png' },
    { id: 5, icon: '/img/about/country/5.png' },
    { id: 6, icon: '/img/about/country/6.png' },
    { id: 7, icon: '/img/about/country/7.png' },
    { id: 8, icon: '/img/about/country/8.png' },
    { id: 9, icon: '/img/about/country/9.png' },
    { id: 10, icon: '/img/about/country/10.png' },
  ]

  // 页面激活后，需要初始化aos
  onMounted(() => {
    AOS.init({
      duration: 2000,
      delay: 5000,
      once: true,
    });
  });
</script>

<script>
  export default {
    name: 'About',
  }
</script>